// @vue/component
export default {
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
};
